import type { NewApptState } from '../types';
import type { PayloadAction } from '@reduxjs/toolkit';

type SetServiceCustomTotalPrice = {
  servicePrice: number;
};

const setServiceCustomTotalPrice = (state: NewApptState, action: PayloadAction<SetServiceCustomTotalPrice>) => {
  state.newAppt.services.custom.totalPrice.value = action.payload.servicePrice;
};

export { setServiceCustomTotalPrice };
